<template>
  <l-cache :get-data="getPartner" :id="this.$route.query.code || ''" ref="cache">
    <partner-form slot-scope="{data}" :partner="data"></partner-form>
  </l-cache>
</template>

<script>

import PartnerForm from './partnerForm'
export default {
  name: 'EditPartner',
  components: {PartnerForm},
  methods: {
    async getPartner (key) {
      let {items} = await this.$store.dispatch('mva/getPartners', {
        pagination: {},
        filterItems: [{value:key}],
        precious: true
      })
      if (!items.length) {
        throw new Error('未找到该合作用户')
      }
      return items[0]
    },
  }
}
</script>

<style scoped>

</style>
